<main class="dash-content">
  <div class="grid">
    <div class="col-12">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.tramite-by-dependencia' | translate }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-bar #chartBarDependencia [config]="barDependenciaConfig" style="min-height:180px" />
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.global-tramites' | translate }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-donut #chartDonutTotal [config]="chartDonutConfig" />
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.efectividad-global' | translate }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-radial-gauge #chartRadialGaugeEfectividad [config]="radialGaugeEfectividadConfig" />
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.historico-tramites-by-mes' | translate }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-line #chartLineHistorico [config]="lineHistoricoConfig" />
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div class="inline-flex align-items-center gap-2">
            <h2 class="dash-title mb-0">{{ 'components.dashboard-general.top-5-efectividad-by-dependencia' | translate
              }}</h2>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-bar #chartBarTopEfectividad [config]="barTopEfectividadConfig" />
        </div>
      </div>
    </div>
  </div>
</main>
